import { useMemo } from 'react';

export const useTableData = (shipments: any[] | undefined, fields: any[] | undefined) => {
  const tableData = useMemo(() => {
    if (!shipments || !fields) return [];

    if (shipments.length === 0) {
      return Array(3)
        .fill(null)
        .map(() => {
          const rowData: Record<string, any> = {};
          fields.forEach((field: any) => {
            rowData[field.key] = null;
          });
          return rowData;
        });
    }

    return shipments.map((shipment: any) => {
      const rowData: Record<string, any> = { id: shipment.id };
      fields.forEach((field: any) => {
        rowData[field.key] = null;
      });
      if (shipment.customFields) {
        Object.assign(rowData, shipment.customFields);
      }
      return rowData;
    });
  }, [shipments, fields]);

  // O(1) lookup map for shipments
  const shipmentsMap = useMemo(() => {
    if (!shipments) return {};
    return shipments.reduce((acc, shipment) => {
      acc[shipment.id] = shipment;
      return acc;
    }, {} as Record<string, any>);
  }, [shipments]);

  return {
    tableData,
    shipmentsMap,
  };
};
